<div id="container">
  <app-popup-availalability-request-infos
    *ngIf="crToDisplayInfos && !crToDisplayInfos.isSwitchRequest"
    [style.top]="crToDisplayInfos.popupYLocation"
    [style.left]="crToDisplayInfos.popupXLocation"
    [cr]="crToDisplayInfos"
    class="popup-availability-request-infos"
  >
  </app-popup-availalability-request-infos>
  <app-popup-switch-request-infos
    *ngIf="crToDisplayInfos && crToDisplayInfos.isSwitchRequest"
    [style.top]="crToDisplayInfos.popupYLocation"
    [style.left]="crToDisplayInfos.popupXLocation"
    [cr]="crToDisplayInfos"
    class="popup-availability-request-infos"
  >
  </app-popup-switch-request-infos>
  <mat-sidenav-container>
    <mat-sidenav
      *ngIf="isConnected"
      disableClose="true"
      [ngClass]="{ 'mat-sidenav-reduced': sideNavReduced }"
      #sidenav
      [opened]="isMenuEnabledStatus"
      mode="side"
      position="start"
    >
      <app-side-nav
        (saveAgendas)="save()"
        [isThereNewModifs]="isThereNewModifs ? isThereNewModifs : false"
        (sidenavToggle)="toggleSideNav()"
        *ngIf="isMenuEnabledStatus"
      >
      </app-side-nav>
    </mat-sidenav>
    <mat-sidenav-content
      [ngClass]="{
        'dark-mode': isNewDarkMode && !isDarkMode,
        dark: !isNewDarkMode && isDarkMode,
        light: !isNewDarkMode && !isDarkMode,
        'small-margin-left': sideNavReduced,
      }"
    >
      <div
        [ngClass]="{ 'dark-mode': isNewDarkMode && !isDarkMode, dark: !isNewDarkMode && isDarkMode }"
        class="router-outlet-container"
        [class.display-none]="isLoading"
      >
        <router-outlet (activate)="onActivate($event)"></router-outlet>
      </div>
      <div *ngIf="isLoading" class="loader-container" fxLayout="row" fxLayoutAlign="center center">
        <mat-spinner diameter="100"></mat-spinner>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <app-tasks-floating-button *ngIf="isConnected" [elevated]="hasUnsavedChanges"></app-tasks-floating-button>
</div>
